import { SMBeamModel, CrossSection, RebarZone } from './types'
import { calculateSectionProperties } from './utils/sectionProperties'
import { buildRebarZones, defaultRebarSpecFor } from './concreteRebarPresets'
import { calculateSelfWeightFromDensity, MATERIAL_PRESETS } from './constants'

const DEFAULT_CONCRETE_DENSITY: number = MATERIAL_PRESETS.concrete.density

function createInitialCrossSection(): CrossSection
{
  const width = 200
  const height = 400
  const area = 0.2 * 0.4
  const inertia = (0.2 * Math.pow(0.4, 3)) / 12

  const baseSection: CrossSection = {
    name: '200×400',
    width,
    height,
    area,
    inertia,
    isCustom: false,
    key: 'CONCRETE_200x400',
    material: 'concrete',
    sectionType: 'rectangular',
    sectionClass: 'auto'
  }

  return {
    ...baseSection,
    ...calculateSectionProperties(baseSection, 'concrete')
  }
}

function createInitialRebarZones(crossSection: CrossSection): RebarZone[]
{
  return buildRebarZones(crossSection, defaultRebarSpecFor(crossSection), 5)
}

export function createInitialModel(): SMBeamModel
{
  const crossSection = createInitialCrossSection()
  const area = crossSection.area
  const selfWeight = calculateSelfWeightFromDensity(area, DEFAULT_CONCRETE_DENSITY)

  return {
    nodes: [
      { id: 1, supportType: 'Pinned', axialFixed: true, position: 0 },
      { id: 2, supportType: 'Roller', axialFixed: false, position: 5 }
    ],
    spans: [
      {
        id: 1,
        leftNodeId: 1,
        rightNodeId: 2,
        length: 5.0,
        E: 30e9,
        A: area,
        I: crossSection.inertia,
        loads: [
          {
            id: 'selfweight-span-1',
            type: 'UniformLoad',
            spanId: 1,
            category: 'Permanent',
            pointLoad: 0,
            pointLoadPosition: 0,
            normalForce: 0,
            normalForcePosition: 0,
            normalForceEccentricity: 0,
            uniformIntensity: -selfWeight,
            startIntensity: -selfWeight,
            endIntensity: -selfWeight,
            startPosition: 0,
            endPosition: 5
          }
        ]
      }
    ],
    loadCases: [],
    crossSection,
    rebarZones: createInitialRebarZones(crossSection),
    designName: '',
    designSessionId: undefined
  }
}

